import { useContext, useState } from "react";
import "./restaurant-menu-item.styles.scss";
import { deleteItem } from "../../../../utils/restaurant-edit";
import { MenuContext } from "../../../../contexts/menu.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
const RMItem = ({ menuItem, itemName }) => {
  const [itemsClass, setItemsClass] = useState("miv-category-items");
  const { setMenuContext, menuContext } = useContext(MenuContext);
  const handleShrink = () => {
    if (itemsClass === "miv-category-items") {
      setItemsClass("miv-category-minimize");
    } else {
      setItemsClass("miv-category-items");
    }
  };
  if (menuItem["metadata"] === "category") {
    return (
      <div className="mi-view-category-container">
        <div className="miv-category-title-container">
          <span className="miv-category-title">{itemName}</span>
          <span className="miv-category-shrink" onClick={handleShrink}>
            {itemsClass === "miv-category-minimize" ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronUp} />
            )}
          </span>
        </div>
        <div className={itemsClass}>
          {Object.keys(menuItem).map((index) => {
            if (index !== "metadata") {
              return (
                <RMItem
                  key={index}
                  menuItem={menuItem[index]}
                  itemName={index}
                />
              );
            }
          })}
        </div>
      </div>
    );
  } else if (menuItem["metadata"] === "item") {
    return (
      <div className="mi-view-item-container">
        <div className="miv-item-details">
          <span className="miv-item-name">{itemName}</span>
          <span className="miv-item-pricevalue">{menuItem["price"]}</span>
          <span className="miv-item-description">
            {menuItem["description"]}
          </span>
        </div>
        <div className="miv-item-options">
          <span
            className="miv-item-delete"
            onClick={() => {
              setMenuContext(deleteItem(menuItem, itemName, menuContext));
            }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </span>
        </div>
      </div>
    );
  }
};
export default RMItem;
